'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useId, useState } from 'react';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { stack } from '@/uiPrimitives/layout/stack';
import { getHasUnansweredQuestions } from './_data/filterQuestions';
import { useGivenAnswers } from './_data/useGivenAnswers';
import { Questions } from './_questions/Questions';
import { Results } from './_results/Results';
import { ResultCategorisationRendered, ResultRendered } from '@/app/decisionToolArticle/_data/decisionToolRendered.types';
import { AnyRenderedQuestion } from './_questions/question.types';
import { useStartQuestionTransition } from './useStartQuestionTransition';
export const DecisionToolClient = t0 => {
  const $ = _c(24);
  const {
    questions,
    resultCategorisationsRendered,
    resultsRendered,
    pageTitle
  } = t0;
  const currentQuestionElId = useId();
  const [givenAnswers] = useGivenAnswers(questions);
  let t1;
  if ($[0] !== givenAnswers || $[1] !== questions) {
    t1 = getHasUnansweredQuestions(questions, givenAnswers);
    $[0] = givenAnswers;
    $[1] = questions;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const hasUnansweredQuestions = t1;
  const [hasStartedDecisionTool, setHasStartedDecisionTool] = useState(false);
  let t2;
  if ($[3] !== hasUnansweredQuestions) {
    t2 = () => !hasUnansweredQuestions;
    $[3] = hasUnansweredQuestions;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const [hasViewedResult, setHasViewedResult] = useState(t2);
  const {
    startQuestionTransition,
    isDelayElapsed
  } = useStartQuestionTransition(currentQuestionElId);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setHasStartedDecisionTool(true);
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const markDecisionToolStarted = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setHasStartedDecisionTool(true);
      setHasViewedResult(true);
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const markResultViewed = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = classes(stack({
      rowGap: "8 | betweenCards"
    }));
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== currentQuestionElId || $[9] !== hasStartedDecisionTool || $[10] !== hasViewedResult || $[11] !== isDelayElapsed || $[12] !== questions || $[13] !== startQuestionTransition) {
    t6 = <Questions questions={questions} currentQuestionElId={currentQuestionElId} startQuestionTransition={startQuestionTransition} isDelayElapsed={isDelayElapsed} hasStartedDecisionTool={hasStartedDecisionTool} hasViewedResult={hasViewedResult} onDecisionToolStarted={markDecisionToolStarted} onResultViewed={markResultViewed} />;
    $[8] = currentQuestionElId;
    $[9] = hasStartedDecisionTool;
    $[10] = hasViewedResult;
    $[11] = isDelayElapsed;
    $[12] = questions;
    $[13] = startQuestionTransition;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== isDelayElapsed || $[16] !== pageTitle || $[17] !== questions || $[18] !== resultCategorisationsRendered || $[19] !== resultsRendered) {
    t7 = <Results isDelayElapsed={isDelayElapsed} pageTitle={pageTitle} resultCategorisations={resultCategorisationsRendered} results={resultsRendered} questions={questions} />;
    $[15] = isDelayElapsed;
    $[16] = pageTitle;
    $[17] = questions;
    $[18] = resultCategorisationsRendered;
    $[19] = resultsRendered;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t6 || $[22] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};